export default {
  gpshopperBlue: "#2b81b9",
  gpshopperGreen: "#26a69a",
  gpshopperDarkGray: "#DDDDDD",
  gpshopperLightGrey: "#eeeeee",
  gpshopperWhite: "#f9f9f9",
  gpshopperDarkgrey: '#9b9b9b',
  colorbannerRow: "#808080",
  gpshopperOrange: "#ffa726",
  gpshopperWhite2: "#FFFFFF",
  gpshopperRed: "red",
  gpshopperCharacterCountColor: "#9B9B9B",
  gpshopperCharcoalShade: "#4a4a4a",
  buttonBackground: "#2b81b9",
  textErrorColor: "red",
};
